import { ResizeMode, Video } from "expo-av";
import { Image } from "expo-image";
import React from "react";
import {
  ActivityIndicator,
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import { complicesStyles } from "@/Components/Screens/Recursos/RecursosStyle";
import useMediaType from "@/hooks/useMediaType";
import Markdown from "react-native-markdown-display";
import { useGlobal } from "../../Context/globalContext";

const ModalPremi = ({
  modalPremiVisible,
  setModalPremiVisible,
  premi,
  itinerari,
  callback,
  isLoading,
  poiId,
}) => {
  const { __, textRecurs } = useGlobal();

  const source: string = __(premi, "multimedia")?.url;
  const isPremi115 = premi?.id === 115;

  const MediaDisplay = ({ source }) => {
    const mediaType = useMediaType(source);

    if (mediaType === "image") {
      return (
        <Image
          placeholder={require("@/assets/Images/loading.gif")}
          source={{ uri: source }}
          style={[
            style.commonStyle,
            isPremi115 && style.premi115Image,
            poiId == 42 && { height: 468 },
          ]}
          contentFit={"contain"}
        />
      );
    }

    if (mediaType === "video") {
      return (
        <Video
          source={{ uri: source }}
          style={[style.commonStyle, poiId === 42 && { height: 468 }]}
          useNativeControls
          resizeMode={ResizeMode.CONTAIN}
          rate={1.0}
          volume={1.0}
          isMuted={false}
          shouldPlay={true}
          videoStyle={{
            width: "100%",
            height: "100%",
          }}
        />
      );
    }

    if (mediaType === "none") {
      return;
    }

    return <ActivityIndicator style={style.commonStyle} />;
  };

  const PremiText = () => (
    <ScrollView
      style={style.textScroll}
      showsVerticalScrollIndicator={true}
    >
      <Markdown
        style={{
          body: {
            fontSize: 16,
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      >
        {__(premi, "popup_text") || " "}
      </Markdown>
    </ScrollView>
  );

  return (
    <Modal
      transparent={true}
      visible={modalPremiVisible}
      onRequestClose={() => setModalPremiVisible(false)}
    >
      <View style={complicesStyles.modalContainer}>
        <View
          style={{
            flexDirection: "column",
            borderRadius: 12,
            backgroundColor: "#F9F7E8",
            marginTop: 10,
            alignItems: "flex-start",
            width: "92%",
            padding: 10,
          }}
        >
          <View
            style={{
              width: "100%",
            }}
          >
            {__(premi, "popup_titol") && (
              <Text
                style={{
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  fontSize: 20,
                  textAlign: "center",
                }}
              >
                {__(premi, "popup_titol")}
              </Text>
            )}

            {isPremi115 && <MediaDisplay source={source} />}

            <PremiText />

            {!isPremi115 && <MediaDisplay source={source} />}
          </View>

          <TouchableOpacity
            style={{
              backgroundColor: itinerari.color_fons2,
              width: 250,
              borderRadius: 6,
              marginTop: 10,
              alignSelf: "center",
            }}
            onPress={callback}
          >
            {isLoading ? (
              <ActivityIndicator />
            ) : (
              <Text
                style={{
                  color: "white",
                  textAlign: "center",
                  padding: 20,
                  fontFamily: "Roboto",
                  fontWeight: "700",
                }}
              >
                {textRecurs("perfil_guardar")}
              </Text>
            )}
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

export default ModalPremi;

const style = StyleSheet.create({
  textScroll: {
    maxHeight: 180,
    width: "100%",
  },
  premi115Image: {
    marginTop: 16,
    marginBottom: 18,
  },
  commonStyle: {
    width: "100%",
    height: 250,
    aspectRatio: 1,
    borderRadius: 12,
    marginVertical: 10,
    alignSelf: "center",
  },
});
